import { AutoComplete, Dropdown } from '~/components';
import { useApi, useWorkspace } from '~/contexts';
import { useIsMounted } from '~/hooks';
import _ from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';

function ContactSelect({ filterContacts, onChange }) {
  const api = useApi();
  const isMounted = useIsMounted();
  const { workspace } = useWorkspace();
  const [defaultOptions, setDefaultOptions] = useState([]);

  const handleSearch = useCallback(
    async (q) => {
      // Associating requires edit on both edges, so only offer contacts the member can edit.
      const { data } = await api.www.workspaces(workspace.id).contacts().options({ q, permission: 'edit' });

      if (filterContacts) {
        _.remove(data, (x) => filterContacts.map((x) => x.id).includes(x.id));
      }

      return data;
    },
    [workspace.id, filterContacts, api],
  );

  useEffect(() => {
    (async () => {
      const data = await handleSearch('');
      if (!isMounted.current) return;
      setDefaultOptions(data);
    })();
  }, [handleSearch, isMounted]);

  const handleChange = (event) => {
    const changeArgument = { target: { value: event.target.value } };
    onChange(changeArgument);
  };

  return (
    <AutoComplete
      onSearch={handleSearch}
      defaultOptions={defaultOptions}
      onChange={handleChange}
      placeholder="Select a contact">
      {({ options }) => {
        let index = 0;

        return options.length > 0 ? (
          options.map((o) => {
            return (
              <AutoComplete.Option padding="0.25rem 0 0.25rem 2rem" key={o.id} value={o} index={index++}>
                {o.name}
              </AutoComplete.Option>
            );
          })
        ) : (
          <Dropdown.Text>None</Dropdown.Text>
        );
      }}
    </AutoComplete>
  );
}

export default ContactSelect;
